import { TodoState } from "../../../../ApiOld/Api/ApiServerVov";

export const getMarkerColor = (marker: { state?: TodoState, mapTagColor?: string }, colorByStates: boolean = true) => {
    if (colorByStates) {
        switch (marker.state) {
            case TodoState.NEW:
                return '#FFC600';
            case TodoState.CLOSED:
            case TodoState.RESOLVED:
                return '#19CB40';
            case TodoState.ACTIVE:
                return '#107AB0';
            default:
                return marker.mapTagColor ?? '#000000';
        }
    }
    return marker.mapTagColor;
};